export default __webpack_public_path__ + "locales/ar-SA/ChangeUserStatusDialog.json?hash=04efd658c8ad4b5ab0d5eb58be241113";